var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwoBigBalls(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 98,
    viewBox: "0 0 224 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.829 90.006C33.2697 94.1432 11.628 79.2091 7.49087 56.6499C3.35371 34.0907 21.8562 11.7945 40.847 8.31179C63.4062 4.17463 85.0479 19.1087 89.1851 41.6679C93.3222 64.2271 78.3882 85.8688 55.829 90.006Z",
    fill: "#FF9C00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.991 90.006C160.432 94.1432 138.79 79.2091 134.653 56.6499C130.516 34.0907 149.019 11.7945 168.009 8.31179C190.569 4.17463 212.21 19.1087 216.347 41.6679C220.485 64.2271 205.551 85.8688 182.991 90.006Z",
    fill: "#FF9C00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoBigBalls);
export default __webpack_public_path__ + "static/media/two-big-balls.d690c80342764e022510ecf8821fe1ad.svg";
export { ForwardRef as ReactComponent };